import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Header.css"; 
import logo from "../assets/66826e00fddae23ee8d69cb6217278d46a998ae6.png";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string>("");
  const [userEmail, setUserEmail] = useState<string>("");
  const [userRole, setUserRole] = useState<number | null>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const userData = localStorage.getItem("gp_user");
    
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setUserName(parsedUser.name || parsedUser.username || "User");
        setUserEmail(parsedUser.email || "");
        setUserRole(parsedUser.role_id || null);
      } catch (error) {
        console.error("Invalid user JSON", error);
      }
    } else {
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("auth");
    localStorage.removeItem("gp_token");
    localStorage.removeItem("gp_phone");
    localStorage.removeItem("gp_user");

    navigate("/");
    window.location.reload();
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogoClick = () => {
    const roleId = userRole ? Number(userRole) : null;
    const isAdmin = roleId ? [1, 2, 3, 7, 8].includes(roleId) : false;
    const isGlobalPartner = roleId === 28;

    if (isAdmin) {
      navigate("/admin");
    } else if (isGlobalPartner) {
      navigate("/dashboard");
    } else {
      navigate("/dashboard"); 
    }
  };

 

  return (
    <div className="header-set">
      <header className="header">
        <div className="branding" onClick={handleLogoClick} style={{ cursor: "pointer" }}>
          <img src={logo} alt="logo" className="logo" />
        </div>
        <div className="user-section" ref={dropdownRef}>
          <div className="user-info" onClick={toggleDropdown}>
            <div className="user-details">
              <span className="user-name">Welcome, {userName}</span>
            </div>
            <svg 
              className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`} 
              width="12" 
              height="8" 
              viewBox="0 0 12 8" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M1 1.5L6 6.5L11 1.5" 
                stroke="white" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
          {isDropdownOpen && (
            <div className="dropdown-menu">
              <div className="dropdown-item user-detail">
                <div className="dropdown-user-info">
                  <div className="dropdown-user-name">{userName}</div>
                  <div className="dropdown-user-email">{userEmail}</div>
                </div>
              </div>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item logout-item" onClick={handleLogout}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Logout
              </button>
            </div>
          )}
        </div>
      </header>
    </div>
  );
};

export default Header;